import { useState } from 'react';
import toast from 'react-hot-toast';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import { useUpdateTransferSession } from '../contexts/transfers';

const today = () => new Date().toLocaleDateString('en-CA');

// Edita el encabezado de la sesión TE: fecha + estado (PATCH /transfer-sessions/:id).
// La finca NO se edita acá (cambiarla rompería la consistencia receptora↔finca, 0023).
export default function SessionEditModal({ session, onClose, onSaved }) {
    const { mutateAsync: updateSession, isPending } = useUpdateTransferSession(session.id);
    const cardRef = useModalDialog(onClose);
    const [date, setDate] = useState(session.date ? String(session.date).slice(0, 10) : today());
    const [status, setStatus] = useState(session.status ?? 2);

    const save = async () => {
        try {
            await updateSession({ date, status: Number(status) });
            toast.success('Sesión actualizada');
            onSaved?.();
            onClose();
        } catch (err) {
            toast.error(err?.message || 'No se pudo actualizar la sesión');
        }
    };

    return (
        <div className="transfer-modal">
            <div className="transfer-modal__overlay" onClick={onClose} aria-hidden="true" />
            <div className="transfer-modal__card" role="dialog" aria-modal="true" aria-label="Editar sesión de transferencia" ref={cardRef}>
                <header className="transfer-modal__head">
                    <h2 className="transfer-modal__title">Editar sesión · {session.code}</h2>
                    <button type="button" className="transfer-modal__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>

                <div className="transfer-modal__body">
                    <div className="transfer-field">
                        <span className="transfer-field__label">Fecha de la jornada</span>
                        <input type="date" className="transfer-field__date" value={date} max={today()} onChange={(e) => setDate(e.target.value)} disabled={isPending} />
                    </div>
                    <div className="transfer-field">
                        <span className="transfer-field__label">Estado</span>
                        <select value={status} onChange={(e) => setStatus(e.target.value)} disabled={isPending}>
                            <option value={2}>Activa</option>
                            <option value={1}>Inactiva</option>
                        </select>
                    </div>
                    <span className="transfer-field__hint">La finca se gestiona desde las receptoras (identidad por finca).</span>
                </div>

                <footer className="transfer-modal__foot">
                    <button type="button" className="transfer-modal__cancel" onClick={onClose} disabled={isPending}>Cancelar</button>
                    <button type="button" className="transfer-modal__continue" onClick={save} disabled={isPending}>{isPending ? 'Guardando…' : 'Guardar'}</button>
                </footer>
            </div>
        </div>
    );
}
